"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseColor = exports.mixColors = void 0;
function mixColors(from, to, point = 1) {
    const fromColor = parseColor(from);
    const toColor = parseColor(to);
    const r = fixColor(fromColor.r, toColor.r, point);
    const g = fixColor(fromColor.g, toColor.g, point);
    const b = fixColor(fromColor.b, toColor.b, point);
    const a = fixAlpha(fromColor.a, toColor.a, point);
    return `rgba(${r},${g},${b},${a})`;
}
exports.mixColors = mixColors;
function parseColor(str) {
    if (str.search(/#/) === 0) {
        const core = str.replace(/#/, '');
        if (core.length === 3) {
            return {
                r: parseInt(core[0] + core[0], 16),
                g: parseInt(core[1] + core[1], 16),
                b: parseInt(core[2] + core[2], 16),
                a: 1,
            };
        }
        if (core.length === 6) {
            return {
                r: parseInt(core[0] + core[1], 16),
                g: parseInt(core[2] + core[3], 16),
                b: parseInt(core[4] + core[5], 16),
                a: 1,
            };
        }
        if (core.length === 8) {
            return {
                r: parseInt(core[0] + core[1], 16),
                g: parseInt(core[2] + core[3], 16),
                b: parseInt(core[4] + core[5], 16),
                a: parseInt(core[6] + core[7], 16) / 255,
            };
        }
    }
    if (str.search(/rgba\(/) === 0) {
        const data = str.replace(/rgba\(|\)|\s+/g, '');
        const arr = data.split(',');
        return { r: Number(arr[0]), g: Number(arr[1]), b: Number(arr[2]), a: Number(arr[3]) };
    }
    else if (str.search(/rgb\(/) === 0) {
        str = str.replace(/rgb\(|\)|\s+/g, '');
        const arr = str.split(',');
        return { r: Number(arr[0]), g: Number(arr[1]), b: Number(arr[2]), a: 1 };
    }
    throw new Error('Unable to parse color: ' + str);
}
exports.parseColor = parseColor;
function fixColor(a, b, t) {
    const fix = a + (b - a) * t;
    let n = a !== b ? fix : a;
    n = n > 255 ? 255 : n;
    return Math.floor(n);
}
function fixAlpha(a, b, t) {
    t = 1 - t < 0 ? 0 : 1 - t;
    let n;
    if (a * b === 1) {
        n = 1;
    }
    else if (a === 0) {
        n = b * t;
    }
    else if (b === 0) {
        n = a * t;
    }
    else if (t === 0) {
        n = a * b;
    }
    else {
        n = a * b * t;
    }
    n = n > 1 ? 1 : n;
    n = n < 0 ? 0 : n;
    return n.toFixed(2);
}
//# sourceMappingURL=mixColors.js.map